/* eslint-disable */
import { useEffect, useState } from 'react';
import { Typography, makeStyles, Grid } from '@material-ui/core';
import { ALL_ROUTES } from 'config/routes';
import { useDispatch, useSelector } from 'react-redux';
import { navigateToRoute } from '../../redux_store';
import Loader from '../Shared/Loader';
import Dashboard from '../App/widgets/Dashboard';
import RoundedButton from '../Shared/RoundedButton';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 32,
    fontWeight: 600,
    marginBottom: 16,
    color: '#333',
  },
  subtitle: {
    fontSize: 16,
    color: '#666',
    marginBottom: 24,
    textAlign: 'center',
    maxWidth: 400,
  },
  icon: {
    fontSize: 80,
    color: '#999',
    marginBottom: 24,
  },
  link: {
    fontSize: 16,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  linkContainer: {
    width: '100%',
    height: '100%',
  },
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  actionButton: {
    textTransform: 'uppercase',
    borderRadius: 8,
    padding: theme.spacing(1.5, 2),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
    [theme.breakpoints.down('sm')]: {
      minWidth: 100,
      padding: theme.spacing(1, 2),
      fontSize: 13,
    },
  },
}));

const NotFound = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const classes = useStyles();
  const {
    isLogin,
    user,
    status,
    metadataStatus,
    metadata,
  } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [showNotFound, setShowNotFound] = useState(false);

  const handleDashboardClick = () => {
    dispatch(navigateToRoute({ route: { path: ALL_ROUTES.root.path }}));
  };

  useEffect(() => {
    if (isLogin === true && metadata !== null && user !== null) {
      setShowNotFound(true);
    }

    if (isLogin === false) {
      dispatch(navigateToRoute({ route: { path: ALL_ROUTES.login.path, removeQueryString: true, forceLoad: true }}));
    }
  }, [metadata, status, metadataStatus, isLogin]);


  if (isLogin === null || metadata == null || user === null || !showNotFound) {
    return <Grid container className={classes.linkContainer} direction='column' alignItems='center'
                 justify='center'>
      <Loader fullHeight />
    </Grid>;
  } else {
    return (
      <Dashboard>
        <div className={classes.container}>
          <svg className={classes.icon} width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2V8H20" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 9V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 16.5H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <Typography className={classes.title}>Page not found.</Typography>
          <Typography className={classes.subtitle}>
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </Typography>
          <RoundedButton
            variant='contained'
            color='primary'
            onClick={handleDashboardClick}
            className={classes.actionButton}
          >
            {titles.open}
            {' '}
            {titles.rootPage}
          </RoundedButton>
        </div>
      </Dashboard>
    );
  }
};

export default NotFound;
